// Vendor imports
const NukaCarousel = require('nuka-carousel').default
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('BaseCarousel')

class BaseCarousel extends NukaCarousel {
  // Work-around slide height calculation bug:
  getSlideHeight(props, childNodes = []) {
    /**
     * nuka-carousel's implementation uses the `.slider-slide` height.
     * The height of the `.slider-slide` wrapper matches `.slider-list`,
     * which does not update when the height of the actual slide changes.
     */
    const currentSliderSlideNode = childNodes[this.state.currentSlide]
    const currentActualSlideNode = currentSliderSlideNode.firstChild
    return currentActualSlideNode.offsetHeight
  }
}

BaseCarousel.defaultProps = {
  // https://github.com/FormidableLabs/nuka-carousel/#props
  ...NukaCarousel.defaultProps,
  // Override Values
  className: bem.block(),
  wrapAround: true
}

module.exports = Object.assign(BaseCarousel, {
  renderDots,
  renderLeftButton,
  renderRightButton
})

function renderDots(carouselProps) {
  const {
    bemEntity = bem,
    currentSlide,
    goToSlide,
    slideCount,
    slidesToScroll
  } = carouselProps
  const dotIndexes = []
  for (let i = 0; i < slideCount; i += slidesToScroll) {
    dotIndexes.push(i)
  }
  return tag('div', {
    className: bemEntity.element('dots')
  },
    dotIndexes.map(index => {
      return tag('button', {
        key: `dot:${index}`,
        className: bemEntity.element('dot', {
          active: currentSlide === index
        }),
        onClick: goToSlide.bind(null, index)
      })
    })
  )
}

function renderLeftButton(carouselProps) {
  const {
    bemEntity = bem,
    currentSlide,
    previousSlide,
    slideCount,
    wrapAround
  } = carouselProps
  const isDisabled = (!wrapAround && currentSlide === 0) || slideCount === 0
  return tag('button', {
    className: bemEntity.element('button', {
      left: true,
      disabled: isDisabled
    }),
    disabled: isDisabled,
    onClick: previousSlide
  })
}

function renderRightButton(carouselProps) {
  const {
    bemEntity = bem,
    currentSlide,
    nextSlide,
    slideCount,
    slidesToScroll,
    wrapAround
  } = carouselProps
  const isDisabled = !wrapAround && currentSlide + slidesToScroll >= slideCount
  return tag('button', {
    className: bemEntity.element('button', {
      right: true,
      disabled: isDisabled
    }),
    disabled: isDisabled,
    onClick: nextSlide
  })
}
